import { render, staticRenderFns } from "./addSupplyChain.vue?vue&type=template&id=06d146e8&scoped=true"
import script from "./addSupplyChain.vue?vue&type=script&lang=js"
export * from "./addSupplyChain.vue?vue&type=script&lang=js"
import style0 from "./addSupplyChain.vue?vue&type=style&index=0&id=06d146e8&prod&lang=css"
import style1 from "./addSupplyChain.vue?vue&type=style&index=1&id=06d146e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d146e8",
  null
  
)

export default component.exports